import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterPanel = ({
  selectedLocation,
  onLocationChange,
  selectedProgramType,
  onProgramTypeChange,
  selectedDuration,
  onDurationChange,
  selectedDeadline,
  onDeadlineChange,
  onResetFilters,
  activeFilterCount,
  isMobileFilterOpen,
  onCloseMobileFilter
}) => {
  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    { value: 'beijing', label: 'Beijing' },
    { value: 'shanghai', label: 'Shanghai' },
    { value: 'guangzhou', label: 'Guangzhou' },
    { value: 'shenzhen', label: 'Shenzhen' },
    { value: 'chengdu', label: 'Chengdu' },
    { value: 'hangzhou', label: 'Hangzhou' },
    { value: 'xian', label: "Xi\'an" },
    { value: 'nanjing', label: 'Nanjing' }
  ];

  const programTypeOptions = [
    { value: 'all', label: 'All Program Types' },
    { value: 'language', label: 'Language Programs' },
    { value: 'preparatory', label: 'Preparatory Classes' },
    { value: 'intensive', label: 'Intensive Courses' },
    { value: 'business', label: 'Business Chinese' }
  ];

  const durationOptions = [
    { value: 'all', label: 'Any Duration' },
    { value: '1-3', label: '1-3 months' },
    { value: '3-6', label: '3-6 months' },
    { value: '6-12', label: '6-12 months' },
    { value: '12+', label: '12+ months' }
  ];

  const deadlineOptions = [
    { value: 'all', label: 'All Deadlines' },
    { value: 'next-month', label: 'Next Month' },
    { value: 'next-3-months', label: 'Next 3 Months' },
    { value: 'next-6-months', label: 'Next 6 Months' },
    { value: 'open', label: 'Open Applications' }
  ];

  const filterContent = (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Location"
          options={locationOptions}
          value={selectedLocation}
          onChange={onLocationChange}
          searchable
        />

        <Select
          label="Program Type"
          options={programTypeOptions}
          value={selectedProgramType}
          onChange={onProgramTypeChange}
        />

        <Select
          label="Duration"
          options={durationOptions}
          value={selectedDuration}
          onChange={onDurationChange}
        />

        <Select
          label="Application Deadline"
          options={deadlineOptions}
          value={selectedDeadline}
          onChange={onDeadlineChange}
        />
      </div>

      {activeFilterCount > 0 && (
        <div className="flex items-center justify-between pt-4 border-t border-border">
          <span className="text-sm text-muted-foreground font-caption">
            {activeFilterCount} filter{activeFilterCount > 1 ? 's' : ''} applied
          </span>
          <Button
            variant="ghost"
            size="sm"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onResetFilters}
          >
            Reset Filters
          </Button>
        </div>
      )}
    </>
  );

  return (
    <>
      <div className="hidden md:block bg-card rounded-lg p-6 shadow-warm-sm border border-border">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
            <Icon name="Filter" size={20} color="var(--color-primary)" />
            Filter Programs
          </h3>
        </div>
        {filterContent}
      </div>

      {isMobileFilterOpen && (
        <div className="md:hidden fixed inset-0 z-[110] bg-background/80 backdrop-blur-sm">
          <div className="fixed inset-x-0 bottom-0 bg-card rounded-t-2xl shadow-warm-xl max-h-[85vh] overflow-y-auto">
            <div className="sticky top-0 bg-card border-b border-border p-4 flex items-center justify-between">
              <h3 className="text-lg font-heading font-semibold text-foreground">
                Filter Programs
              </h3>
              <button
                onClick={onCloseMobileFilter}
                className="p-2 rounded-md hover:bg-muted transition-smooth"
                aria-label="Close filters"
              >
                <Icon name="X" size={24} color="var(--color-foreground)" />
              </button>
            </div>
            <div className="p-6 space-y-4">
              {filterContent}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FilterPanel;